// src/store/driver.js
import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';  // 假設你有一個封裝的 HTTP 客戶端
import { ref } from 'vue';
import { statusCheck } from '../public';

export const useDriverStore = defineStore('driverProfile', () => {
  const autoPayPauseModal = ref({
    visible: false,
    title: '',
    message: '',
    eventId: null,
  });

  const driverInfo = ref({
    first_name: '',
    middle_name: '',
    last_name: '',
    driver_id: '',
    plate_number: '',
    abn: '',
  });

  const fetchDriverInfo = async () => {
    try {
      const response = await useHttp().get('/api/driver/driver/info');
      if (statusCheck(response.data)) {
        driverInfo.value = response.data.result;
      } else {
        console.error('Failed to fetch driver info:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching driver info:', error);
    }
  };

  const updateDriverInfo = async (updatedFields) => {
    try {
      const response = await useHttp().post('/api/driver/driver/update', updatedFields);
      if (statusCheck(response.data)) {
        // 更新成功後重新獲取駕駛員信息
        await fetchDriverInfo();
      } else {
        console.error('Failed to update driver info:', response.statusText);
      }
    } catch (error) {
      console.error('Error updating driver info:', error);
    }
  };

  const changeAccount = async (account_detail_id) =>{
    try {
      const response = await useHttp().post('/api/driver/driver/update_account', {
        account_detail_id : account_detail_id,}
      );
      if (statusCheck(response.data)) {
        await fetchDriverInfo();
      } else {
        console.error('Failed to update driver info:', response.statusText);
      }
    } catch (error) {
      console.error('Error updating driver info:', error);
    }
  }

  const updateAutoPay = async (account_detail_id,auto_pay) => {
    try{
      const response = await useHttp().post('/api/driver/driver/update_auto_pay',{
        account_detail_id : account_detail_id,
        auto_pay : auto_pay
      });
      if (statusCheck(response.data)) {
        await fetchDriverInfo();
      } else {
        console.error('Failed to update auto pay:', response.statusText);
      }
    }catch(error){
      console.error('Error updating auto pay:', error);
    }
  }

  const fetchAutoPayPauseModal = async () => {
    try {
      const response = await useHttp().get('/api/driver/auto-pay/pause-modal');
      const data = response.data;
      if (data.success && data.show && data.message) {
        autoPayPauseModal.value = {
          visible: true,
          title: data.title || 'Auto Pay paused',
          message: data.message,
          eventId: data.event_id ?? null,
        };
      }
    } catch (error) {
      console.error('Error fetching auto pay pause modal:', error);
    }
  };

  const closeAutoPayPauseModal = async (dontShowAgain = false) => {
    const { eventId } = autoPayPauseModal.value;
    autoPayPauseModal.value.visible = false;

    if (eventId != null) {
      try {
        await useHttp().post('/api/driver/auto-pay/pause-modal/ack', {
          event_id: eventId,
          dont_show_again: dontShowAgain,
        });
      } catch (error) {
        console.error('Error acknowledging auto pay pause modal:', error);
      }
    }
  };

  return {
    driverInfo,
    autoPayPauseModal,
    fetchDriverInfo,
    updateDriverInfo,
    changeAccount,
    updateAutoPay,
    fetchAutoPayPauseModal,
    closeAutoPayPauseModal,
  };
});
